import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
var ModalRejectComponent = /** @class */ (function () {
    function ModalRejectComponent(dialogRef, data, formBuilder, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        console.log('data', data);
    }
    ModalRejectComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalRejectComponent.prototype.submit = function () {
        if (!this.formGroup.valid) {
            this.snackBar.open("Preencha corretamente os campos e tente novamente.");
            return false;
        }
        this.dialogRef.close(this.formGroup.value.reason);
    };
    ModalRejectComponent.prototype.ngOnInit = function () {
        this.formGroup = this.formBuilder.group({
            reason: [null, [
                    Validators.required,
                ]],
        });
    };
    return ModalRejectComponent;
}());
export { ModalRejectComponent };
